import React, { useState } from "react";
import { Select, Divider, Button, Icon } from "antd";

export default function SelectBasico({
  dados,
  setDados,
  getItem,
  addButton,
  ...rest
}) {
  const [cadId, setCadId] = useState(null);

  const save = (savedData) => {
    setCadId(null);
    setDados([...dados, savedData]);
    rest.onChange(savedData.key);
  };

  return (
    <>
      <div
        onMouseDown={(e) => {
          e.preventDefault();
          return false;
        }}
      >
        <Select
          showSearch
          allowClear
          multisel
          {...rest}
          style={{ width: "100%", ...rest.style }}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
          dropdownStyle={{ zIndex: rest.zIndex }}
          dropdownRender={(menu) => (
            <div>
              {menu}
              {addButton && (
                <>
                  <Divider style={{ margin: "4px 0", marginBottom: 0 }} />
                  <div style={{ padding: "8px", textAlign: "center" }}>
                    <button
                      className="btn btn-link"
                      onClick={() => setCadId(0)}
                      style={{ padding: 0 }}
                    >
                      Incluir Novo
                    </button>
                  </div>
                </>
              )}
            </div>
          )}
        >
          {(dados || []).map((item) => (
            <Select.Option key={item.id} value={item.id}>
              {getItem ? getItem(item) : item.nome}
            </Select.Option>
          ))}
        </Select>
      </div>
    </>
  );
}
